module.exports = __webpack_public_path__ + "media/images/loader-6c4cecbddd347279fd46c27fabd4ffb4.gif";